<style lang="less">
  @import './login.less';
</style>

<template>
  <div class="login">
    <div class="login-con">
      <div>
        <img src="@/assets/images/logo.png" style="width: 320px;"/>
      </div>
      <Card icon="log-in" title="用户登录" :bordered="false">
        <div class="form-con">
          <login-form @on-success-valid="handleSubmit"></login-form>
          <p class="login-tip">输入用户名和密码</p>
        </div>
        <!--<div id="wechatLoginQRCode">二维码位置</div>-->
      </Card>
    </div>
  </div>
</template>

<script>
  import store from '@/store'
  import LoginForm from '_c/login-form'
  import {mapActions} from 'vuex'
  import {setToken, getToken, canTurnTo} from '@/libs/util'

  export default {
    components: {
      LoginForm
    },
    data () {
      return {
        wechatLoginQRCodeObj: null
      }
    },
    methods: {
      ...mapActions([
        'getUserInfo',
        'AccountServ_LoginByNameAndPassword',
        'AccountServ_GetSelfInfo',
        'AccountServ_LoginByWechatUnion'
      ]),
      handleSubmit ({userName, password, webVerifyCode}) {

        let loginForm = {
          name: userName,
          password: password,
          webVerifyCode: webVerifyCode
        }

        this.AccountServ_LoginByNameAndPassword(
          {
            params: loginForm,
            extfunc: (commit, params, urlparams) => {
              console.log('AccountServ_LoginByNameAndPassword ok')
              setToken('adminUser')
              this.$router.push({
                name: this.$config.homeName
              })
            }

          }).then(res => {

        }).catch(err => {
          this.$Message.error(err)
        })

      }
    },
    mounted () {
      this.$nextTick(() => {
        let enRedirectUri = encodeURIComponent('https://webgis.jianchengjt.com/login')

        let code = this.$route.query.code
        let state = this.$route.query.state

        if (code) {
          // 扫码操作
          console.log('扫码操作')
          try {

            this.AccountServ_LoginByWechatUnion({
              params: {code: code, state: state, wechatapptype:1},
              urlparams: null,
              extfunc: (commit, params, urlparams) => {
                setToken('adminUser')
                this.$router.push({
                  name: this.$config.homeName
                })
              }
            }).then(res => {
              this.$Message.success('登录成功')
            }).catch(err => {
              this.$Message.error(err)
              console.log(err)
              this.wechatLoginQRCodeObj = WxLogin({
                self_redirect: false,
                id: 'wechatLoginQRCode',
                appid: 'wxa106f362c2c201c6',
                scope: 'snsapi_login',
                redirect_uri: enRedirectUri,
                state: '',
                style: 'white',
                href: ''
              })
            })

          } catch (e) {
            console.log(e)
          }

        } else {
          //  未扫码
          console.log('未扫码')
          this.wechatLoginQRCodeObj = WxLogin({
            self_redirect: false,
            id: 'wechatLoginQRCode',
            appid: 'wxa106f362c2c201c6',
            scope: 'snsapi_login',
            redirect_uri: enRedirectUri,
            state: '',
            style: 'white',
            href: ''
          })
        }
      })
    }
  }
</script>

<style>

</style>
